import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { v1 as uuidv1 } from 'uuid';
import { useMediaQuery } from 'react-responsive';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';

import useStyles from './styles';

const ButtonGroup = ({ names, selected, title, onClick, altClasses }) => {
  const isMobile = useMediaQuery({ maxWidth: 900 });
  const classes = useStyles();

  const realClasses = useMemo(() => {
    if (!altClasses) return classes;
    return { ...classes, ...altClasses };
  }, [altClasses, classes]);

  const buttonGroupContainer = (
    <div className={realClasses.wrapper}>
      {names.map((name, i) => (
        <button
          key={uuidv1()}
          type="button"
          onClick={() => onClick(i)}
          className={
            selected[i] ? realClasses.activeButton : realClasses.button
          }
        >
          {name}
        </button>
      ))}
    </div>
  );

  return isMobile ? (
    <Accordion>
      <AccordionSummary
        expandIcon={<FontAwesomeIcon icon={faAngleDown} />}
        aria-controls="button-group-content"
        id="button-group-header"
      >
        <div className={classes.buttonGroupTitle}>
          {title}
        </div>
      </AccordionSummary>
      <AccordionDetails>{buttonGroupContainer}</AccordionDetails>
    </Accordion>
  ) : (
    buttonGroupContainer
  );
};

ButtonGroup.defaultProps = {
  onClick: () => {},
  altClasses: null,
};

ButtonGroup.propTypes = {
  names: PropTypes.arrayOf(PropTypes.string).isRequired,
  selected: PropTypes.arrayOf(PropTypes.bool).isRequired,
  title: PropTypes.string,
  onClick: PropTypes.func,
  altClasses: PropTypes.objectOf(PropTypes.string),
};

export default ButtonGroup;
